import { Component } from '@angular/core';
import { SecurityTransaction } from '@models/security-transactions/security-transaction';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import {
  AgActionIconButtonComponent
} from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { Guid } from "@shared/utils/guid.helper";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<unknown> & {
  annotation: ActionEvent,
  downloadCertificate: ActionEvent,
  edit: ActionEvent,
  delete: ActionEvent
};

@Component({
  selector: 'app-ag-share-actions',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    HasRoleDirective,
    AgActionIconButtonComponent
  ],
  templateUrl: 'ag-share-actions.component.html',
  styleUrl: 'ag-share-actions.component.scss'
})
export class AgShareActionsComponent implements ICellRendererAngularComp {
  params!: CellRendererParams;
  isEditTransactionVisible = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    const transaction = params.data as SecurityTransaction;

    this.isEditTransactionVisible = Boolean(!transaction.documentId?.trim() && transaction.securityTransactionId?.trim() && Guid.isValidGuid(transaction.securityTransactionId));
    this.params = params;

    return true;
  }

  annotation(): void {
  }

  downloadCertificate(): void {
  }

  editTransaction(): void {
    this.params.edit(this.params.data as SecurityTransaction);
  }

  deleteTransaction(): void {
    this.params.delete(this.params.data as SecurityTransaction);
  }
}
